const validate = (values, { t }) => {
  const errors = {};
  if (values.requestFinalDate && !values.requestInitialDate) {
    errors.requestInitialDate = t('validations.required-initial-date');
  }
  if (values.requestInitialDate && !values.requestFinalDate) {
    errors.requestFinalDate = t('validations.required-final-date');
  }
  if (
    values.requestFinalDate &&
    values.requestInitialDate &&
    values.requestInitialDate > values.requestFinalDate
  ) {
    errors.requestFinalDate = t('validations.final-date-range');
  }
  return errors;
};
export default validate;
